window.addEventListener('DOMContentLoaded', (event) => {    
   var modal = document.getElementById('video_modal'),   
   modalClose = document.getElementById('close_icon'),
   modalIcon = document.getElementById('video_icon'),       
   video_player = document.getElementById('video_player'),
   videoSrc = document.getElementById('video_player'),
   videoLink= videoSrc.getAttribute('src');
  const body = document.querySelector("body");
  
  modalIcon.onclick = function modalOpen(event) {      
    modal.style.setProperty('opacity', "1");   
    modal.style.setProperty('visibility', 'visible');
    video_player.setAttribute("src", videoLink+"?&amp;autoplay=1");
    body.style.overflow = "hidden";     
    event.preventDefault();        
  }
  
  modalClose.onclick = function closeOpen(event) {
    video_player.setAttribute("src", " ");
    modal.style.setProperty('opacity', "0");     
    modal.style.setProperty('visibility', 'hidden');
    body.style.overflow = "auto";
    event.preventDefault();
  }
  
  modal.onclick = function closeOpen(event) {
    video_player.setAttribute("src", " ");
    modal.style.setProperty('opacity', "0");     
    modal.style.setProperty('visibility', 'hidden');    
    event.preventDefault();
  }
});




